/**
 * Ported from https://github.com/brigand/ink-progress-bar/blob/master/src/index.js
 * `ink-progress-bar` doesn't list react or ink as a direct dependency which messes up
 * installation for users of yarn v2+.
 */
import { Text } from 'ink';

const Bar = ({
  percent = 1,
  columns = 0,
  left = 0,
  right = 0,
  character = '█',
  rightPad = false,
  ...rest
}: {
  percent?: number;
  columns?: number;
  left?: number;
  right?: number;
  character?: string;
  rightPad?: boolean;
}) => {
  const getString = () => {
    const screen = columns || process.stdout.columns || 80;
    const space = screen - right - left;
    const max = Math.min(Math.floor(space * percent), space);
    const chars = character.repeat(max);

    if (!rightPad) {
      return chars;
    }

    return chars + ' '.repeat(space - max);
  };

  return <Text {...rest}>{getString()}</Text>;
};

export default Bar;
